import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { BillChargeService } from "./bill-charge.service";
import { BillCharge } from "./ibill-charge";

@Injectable({
    providedIn: 'root'
})
export class BillChargeResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _billChargeService: BillChargeService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, billCharges: BillCharge[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._billChargeService.getBillCharge(data);
    }
}